/**
 * GR-012: "Google reCaptcha failed with score <score>" in a red error Alert.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {Alert, AlertIcon, AlertTitle} from '@chakra-ui/react';

export const RecaptchaErrorMessage = ({icon, message, ...props}) => {
  if (!message) {
    return null;
  }

  return (
    <Alert
      aria-live="assertive"
      role="alert"
      status="error"
      variant="error"
      {...props}
    >
      <AlertIcon as={icon} />
      <AlertTitle color="red.600">{message}</AlertTitle>
    </Alert>
  );
};

RecaptchaErrorMessage.propTypes = {
  icon: PropTypes.elementType,
  message: PropTypes.string,
};
